const MIN_AGE_APPLICATION = 16;

export { MIN_AGE_APPLICATION };

export const STORAGE_KEYS = {
  pendingReturnUrl: "tiller-verify:returnurl",
};

/** Prefix for every persisted dashboard view entry (localStorage). */
export const DASHBOARD_VIEW_KEY_PREFIX = "tiller-verify:view:";
/** Prefix for every persisted dashboard search-term entry (sessionStorage only). */
export const DASHBOARD_SEARCH_KEY_PREFIX = "tiller-verify:search:";

/**
 * `User.tenant` is optional; a missing tenant id uses "0" rather than the
 * string "undefined" and the resulting entry is treated as disposable.
 */
export const viewKey = (
  dashboard: string,
  tenantId: number | undefined,
  userId: number
) => `${DASHBOARD_VIEW_KEY_PREFIX}${dashboard}:${tenantId ?? 0}:${userId}`;

export const searchKey = (
  dashboard: string,
  tenantId: number | undefined,
  userId: number
) => `${DASHBOARD_SEARCH_KEY_PREFIX}${dashboard}:${tenantId ?? 0}:${userId}`;
